import { isRefNumberDeposit } from 'domains/references/DepositReference';

const DEFAULT_SUPPLIER_NAME = 'RENAULT';

const trim = (value?: string): string => value?.trim() ?? '';

export const getReferenceDisplay = (reference?: string): string => {
  const trimmedReference = trim(reference);
  if (!trimmedReference) {
    return '';
  }

  const strippedReference = trimmedReference.replace(/^0+(?!$)/, '');
  return strippedReference || '0';
};

export const getSupplierNameWithOrderNumberDisplay = (supplierName?: string, orderNumber?: string): string => {
  const trimmedSupplierName = trim(supplierName);
  if (!trimmedSupplierName) {
    return DEFAULT_SUPPLIER_NAME;
  }

  const trimmedOrderNumber = getReferenceDisplay(orderNumber);
  return trimmedOrderNumber ? `${trimmedSupplierName} [${trimmedOrderNumber}]` : trimmedSupplierName;
};

export const getSupplierNameListDisplay = (supplierNames?: string[]): string => {
  const trimmedSupplierNames = supplierNames?.map(trim).filter(Boolean) ?? [];

  if (trimmedSupplierNames.length === 0) {
    return DEFAULT_SUPPLIER_NAME;
  }
  if (trimmedSupplierNames.length === 1) {
    return trimmedSupplierNames.at(0) ?? DEFAULT_SUPPLIER_NAME;
  }

  const firstWords = trimmedSupplierNames.map(function (name) {
    return name.split(' ').at(0) ?? '';
  });

  return firstWords.length > 0 ? firstWords.join(', ') : DEFAULT_SUPPLIER_NAME;
};

export const getSupplierNameDisplay = (supplierName?: string): string => trim(supplierName).split(' ').at(0) ?? '';

export const getPrefillReason = (refNumber: string, fallback: string): string =>
  isRefNumberDeposit(refNumber) ? 'Y9A' : fallback;
